import script from "./BookmarksView.vue?vue&type=script&setup=true&lang=js"
export * from "./BookmarksView.vue?vue&type=script&setup=true&lang=js"

import "./BookmarksView.vue?vue&type=style&index=0&id=017ff4da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017ff4da"]])

export default __exports__